import { Path } from 'enums';
import BooksOfAccountsCashDisbursementModule from 'modules/books-of-accounts/books-of-accounts-cash-disbursement.module';
import BooksOfAccountsCashReceiptModule from 'modules/books-of-accounts/books-of-accounts-cash-receipt.module';
import BooksOfAccountsGeneralEntriesModule from 'modules/books-of-accounts/books-of-accounts-general-entries.module';
import BooksOfAccountsGeneralJournalModule from 'modules/books-of-accounts/books-of-accounts-general-journal.module';
import BooksOfAccountsGeneralLedgerModule from 'modules/books-of-accounts/books-of-accounts-general-ledger.module';

import React from 'react';
import { Route, Switch } from 'react-router-dom';

const BooksOfAccountsPage = () => {
  return (
    <Switch>
      <Route exact path={`${Path.BooksOfAccounts}/general-entries`} component={BooksOfAccountsGeneralEntriesModule} />
      <Route exact path={`${Path.BooksOfAccounts}/cash-disbursement`} component={BooksOfAccountsCashDisbursementModule} />
      <Route exact path={`${Path.BooksOfAccounts}/cash-receipt`} component={BooksOfAccountsCashReceiptModule} />
      <Route exact path={`${Path.BooksOfAccounts}/general-journal`} component={BooksOfAccountsGeneralJournalModule} />
      <Route exact path={`${Path.BooksOfAccounts}/general-ledger`} component={BooksOfAccountsGeneralLedgerModule} />
    </Switch>
  );
};

export default BooksOfAccountsPage;
